

window.main = true;

if (!window.prefetch) {
    window.beacon('info', ['angular_bootstrap_start']);
    angular.bootstrap(document.body, ['app']);
    window.beacon('info', ['angular_bootstrap_end']);
    require('./app.js');
}


/*****************
 ** WEBPACK FOOTER
 ** ./js/bootstrap.js
 ** module id = 0
 ** module chunks = 1
 **/